import * as fromDatatype from "../datatype-library/index";

export interface bl_ppl_ap_validation_test_file_zip_helper_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
    validation_test_file_zip_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.NumericDatatypeInterface;
    file_format: fromDatatype.VarcharDatatypeInterface;
    validation_status: fromDatatype.VarcharDatatypeInterface;
    validation_error: fromDatatype.TextDatatypeInterface;
    file_json: any;
    error_message: fromDatatype.TextDatatypeInterface;
    user_error_message: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_ppl_ap_validation_test_file_zip_helper_RowClass
	implements bl_ppl_ap_validation_test_file_zip_helper_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
    validation_test_file_zip_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.NumericDatatypeInterface;
    file_format: fromDatatype.VarcharDatatypeInterface;
    validation_status: fromDatatype.VarcharDatatypeInterface;
    validation_error: fromDatatype.TextDatatypeInterface;
    file_json: any;
    error_message: fromDatatype.TextDatatypeInterface;
    user_error_message: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
